/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/*tslint:disable:max-file-line-count */
import {
  Component,
  OnInit,
  ViewEncapsulation,
  OnDestroy,
  EventEmitter,
  Input,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NavbarModal } from '../../models/navbar.model';
import { HeaderPrimaryNav } from '@root/shared/models/header-primary-nav.interface';
import { Link } from '../../models/link.interface';
import { NavLink } from '../../models/nav-link.interface';
import { SETTINGS } from '../../../../../environments/settings';
import { GlobalMessages } from '@core/aem/interfaces/global-messages/global-messages.interface';
import { DynamicModal } from '@support/shared/widgets/interfaces/dynamic-modal.interface';
import { StaticModal } from '@support/shared/widgets/interfaces/static-modal.interface';
import { NavbarInterface } from '../../interfaces/navbar.interface';
import { CustomerProfileService } from '@support/customer-login/services/customer-profile.service';
import { NavbarService } from '../../services/navbar.service';
import { StateStoreService } from '@support/state-object-hash-utilities/services/state-store.service';
import { CartSupportService } from '@support/cart-support/services/cart-support.service';
import { Cart, CartLine, CartItem } from '@support/api/proxies/responses/api-cart-response.interface';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import { PROFILE_PERMISSION_CONSTANTS } from '../../constants/profile-permission.constants';
import * as clone from 'clone';
import { CommonUtilService } from '@support/shared/services/common-util.service';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { Wove } from 'aspect.js/';
import { SHARED_CONSTANTS } from '@root/shared/constants/shared-constants.constants';
import { ObjectInterface } from '@support/api/common/api-response.interface';
import { EntryModal } from '@experience/shop/shared-browse/models/entry-modal.model';
import { WindowRefService } from '@support/shared/services/window-ref.service';
import { AutoPayDiscountEligiblePlanInCart } from '@support/api/proxies/responses/prepaid-cart/prepaid-cart.interface';

// pdl
import { PDLBaseComponent } from '@experience/reb-pdl/components/pdl.base.component';
import { PdlService } from '@experience/reb-pdl/services/pdl.service';
import { takeUntil } from 'rxjs/operators';
import { PERMISSION_CONSTANTS } from '@support/shared/constants/permission.constants';
import { FeatureToggleUtilService } from '@support/shared/services/feature-toggle-util.service';
import { HttpResponse } from '@angular/common/http';
declare var MP;
import { UserService } from '@support/shared/services/user.service';

/**
 * Component for the UI navbar.
 * @access protected - used by the Root module
 */
@Wove({ moduleName: SHARED_CONSTANTS.ROOT_SHARED_MODULE })
@Component({
  selector: 'tmo-digital-navbar',
  encapsulation: ViewEncapsulation.None, // allows for style sheet to insert global styles
  templateUrl: './digital-navbar.component.html',
  styleUrls: ['../../../../../style-sheets/theme/digital-navbar.scss'],
  providers: [CustomerProfileService],
})
export class DigitalNavbarComponent extends PDLBaseComponent implements OnInit, OnDestroy {
  /**
   * Stores global messages for the global content
   */
  @Input() public globalContent: GlobalMessages;
  /**
   * Stores header navigation data
   */
  @Input() public headerNavigationContent: HeaderPrimaryNav;
  // public repDashwindow: RepdashWindowRef;
  /**
   * To bind data primary navigation data to view
   */
  public navigationData: HeaderPrimaryNav;
  /**
   * To bind data primary navigation data copy to view
   */
  public filteredNavigationData: HeaderPrimaryNav;
  /**
   * To bind gloabl navigation links to data
   */
  public globalNavLinksData: NavLink[];
  /**
   * Variable to hold zipcode modal button and other data
   */
  public entryModalData: EntryModal;
  /**
   * To bind secondary navigation links to view
   */
  public secondaryMenu: Link[];
  /**
   * To track Index of expanded primary menu
   */
  public openIndex: number;

  /** Constans for the product selector page */
  public navBarConstants: ObjectInterface;
  /**
   * To track if secondary menu is open
   */
  public isSecondaryMenuOpen: boolean;

  /**
   * To track if user is logged in
   */
  public isLoggedIn: boolean;

  /**
   * To track default state of user
   */
  public default: boolean;

  public isMytmoSubMenus: boolean;

  /**
   * To track the breakpoint of screen.
   * This value is passed from MatchMediaServie.
   */
  public isDesktop: boolean;
  /**
   * To track if hamburger menu is open on devices with width less than 992px
   */
  public isMenuClosed: boolean;
  /**
   * Boolean value checks for the multiple accounts
   */
  public hasMutipleAccount: boolean;
  /**
   * Boolean value checks for the web channel
   */
  // public isWebChannel: boolean;
  /**
   * Boolean value checks for the rap channel
   */
  // public isRapChannel: boolean;
  /**
   * Stores the static modal for the modal data
   */
  public modalData: StaticModal;
  /**
   * Mouse event for the top bar link
   */
  public topbarLink: MouseEvent;
  /**
   * model to store dynamic data
   */
  public modal: DynamicModal;

  public partialLines: string[];
  /**
   * string to store first menu link label
   */
  public firstMenuLinkLabel: string;
  /**
   * Unsubscriber for all subscribtions
   */
  public isShowSubMenus: boolean[];

  /**
   * Boolean variable controls if the search bar is displayed as part of the navbar
   */
  public showSearchBar: boolean;
  /**
   * Property to capture pdl event
   */
  public secondaryMenuLink: string;

  /**
   * Count of items in cart to display in the cart icon
   */
  public cartItemCount: number;
  /**
   * Flag to check Tourist Plan Flow
   */
  public isTouristPlanFlow: boolean;
  /**
   * Flag to check permission
   */
  public isAddLinePermission: boolean;
  /**
   * Flag to check permission
   */
  public isPermissionAvailable: boolean;
  /**
   * Flag to check permission
   */
  public isOrderDevicePermission: boolean;
  /**
   * Flag to check permission
   */
  public isAccessoryPermission: boolean;
  /**
   * flag to hide gloabl nav for pre-purchased plan scenarios
   */
  public hideGlobalNav: boolean;
  private ngUnsubscribe: Subject<void>;
  private externalLink: string;
  private myTmobileIndex: number;
  /**
   * Boolean to check if plan is tourist plan
   */
  public isTouristPlan: boolean;

  public navigateTo: string;
  public interactionId: string;
  public isEspanol: boolean;
  public toggleLanguage: string;
  public readonly window: Window;
  public isP10MCustomer: boolean;
  /**
   * boolean to check if rep is to be navigated to plans and services page
   */
  // public shouldNavigateToPlanServices: boolean;

  public eventData: object;

  public index: number;

  public targetUrl: string;

  public subMenu: string;

  public domain: string;

  public showConnect: boolean;

  private lastMouseLeaveIndex: number;

  constructor(
    private navBarService: NavbarService,
    private router: Router,
    private customerProfileService: CustomerProfileService,
    private stateStore: StateStoreService,
    private cartSupportService: CartSupportService,
    private objectService: ObjectService,
    private stateStoreUtils: StateStoreUtilsService,
    private commonUtilService: CommonUtilService,
    private featureToggleUtilService: FeatureToggleUtilService,
    public routeSnapshot: ActivatedRoute,
    private winRefService: WindowRefService,
    private userService: UserService,
    public pdlService: PdlService
  ) {
    super(pdlService, routeSnapshot);
    this.hasMutipleAccount = false;
    this.isMenuClosed = false;
    this.isMytmoSubMenus = false;
    const openindex = -1;
    this.openIndex = openindex;
    const myTmobileindex = -2;
    this.myTmobileIndex = myTmobileindex;
    this.isLoggedIn = false;
    this.isSecondaryMenuOpen = false;
    this.secondaryMenu = [];
    this.isShowSubMenus = [];
    this.navBarConstants = SHARED_CONSTANTS;
    this.entryModalData = new EntryModal();
    this.cartItemCount = 0;
    this.ngUnsubscribe = new Subject<void>();
    this.modal = {
      disableDismiss: false,
      disableEsc: true,
      toggleModalEmitter: new EventEmitter(),
      dismissableMask: true,
      modalName: 'unsaved-selections-modal',
    };
    this.showSearchBar = false;
    this.isTouristPlan = false;
    this.hideGlobalNav = false;
    this.window = this.winRefService.nativeWindow();
    this.isEspanol = false;
    this.isTouristPlanFlow = false;
    this.isAddLinePermission = true;
    this.isPermissionAvailable = true;
    this.isOrderDevicePermission = true;
    this.isAccessoryPermission = true;
    this.closeVerticalMenu();
    this.interactionId = this.stateStoreUtils.getInteractionId();
  }
  /**
   * Initializes the primary navigation links.
   * @returns void
   */
  public ngOnInit(): void {
    this.updateNavbarPermission();
    const loggedOutEventId: string = 'loggedOut';
    // this.isWebChannel = SETTINGS.CHANNEL.toLocaleLowerCase() === 'web';
    this.domain = window.location.protocol + '//' + window.location.host;
    // this.isRapChannel = SETTINGS.CHANNEL.toLocaleLowerCase() === 'nrd';
    // this.repDashwindow = this.windowRefService.nativeWindow();
    // if (this.isWebChannel) {
    this.navigateTo = this.window.location.href;
    if (this.navigateTo.indexOf('//es.') >= 0) {
      this.isEspanol = true;
      this.toggleLanguage = this.navBarConstants.ENGLISH_LANG;
      this.navigateTo = this.navigateTo.replace(/(es\.)/, '');
    } else {
      this.isEspanol = false;
      this.toggleLanguage = this.navBarConstants.SPANISH_LANG;
      const navigateTo = this.navigateTo.split('//');
      this.navigateTo = navigateTo[0] + '//es.' + navigateTo[1];
    }
    // }
    this.modalData = new NavbarModal();
    // To get the data for primary navigation links.
    this.navBarService.navigationData = this.stateStoreUtils.getNavBarData();
    this.globalNavLinksData =
      this.navBarService.navigationData.globalNavLinks.globalnavlinks.navLinks;
    if (document.cookie.includes('brand=connect')) {
      this.showConnect = true;
    } else {
      this.showConnect = false;
    }
    this.getMenuItems();
    this.setPrimaryNavigationData();

    this.modalData.headerText = this.globalContent.globalMessages.leaveSiteHeader;
    this.modalData.bodyText = this.globalContent.globalMessages.leaveSiteBody;
    // To get the data for global navigation links.
    this.navBarService.navbarChangeEmitter
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((event: { id: string }) => {
        if (event.id === 'loggedIn') {
          // @TODO remove hardcoding once web login is fixed
          // this.isLoggedIn = this.navBarService.isLoggedIn();
          this.isLoggedIn = true;
          if (this.navBarService.isLoggedIn() && this.openIndex !== this.myTmobileIndex) {
            this.setPrimaryDataAndGetMenuItems();
          }
        } else if (event.id === 'default') {
          this.isMytmoSubMenus = true;
          this.isLoggedIn = true;
        } else if (event.id === 'default') {
          this.isMytmoSubMenus = true;
          this.isLoggedIn = true;
        } else if (event.id === SHARED_CONSTANTS.ONLY_DEVICE_ORDER) {
          this.isLoggedIn = false;
        } else if (event.id === loggedOutEventId) {
          this.isLoggedIn = this.navBarService.isLoggedIn();
          this.closeSecondaryMenu();
          this.setPrimaryDataAndGetMenuItems();
        }
      });
    this.navBarService.touristPlanEmitter.subscribe((isTouristPlan: boolean) => {
      this.isTouristPlan = isTouristPlan;
    });
    this.userService.p10CustomerLoggedIn$
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((data: boolean) => {
        this.isP10MCustomer = data;
        this.setPrimaryDataAndGetMenuItems();
      });
    this.navBarService.permissionsUpdated.subscribe((isTouristPlan: boolean) => {
      this.updateNavbarPermission();
    });
    this.hasMutipleAccount = this.customerProfileService.multipleAccount
      ? this.customerProfileService.multipleAccount
      : false;

    this.cartSupportService.cartUpdated$.subscribe((updated: boolean) => {
      this.updateCartItemCount();
      if (
        (this.objectService.get(this.stateStoreUtils.getCart(), 'lines.length') || 0) === 0 &&
        this.hideGlobalNav
      ) {
        this.hideGlobalNav = false;
      }
    });
    this.navBarService.hideGlobalNavEmitter.subscribe((hideNavBar: boolean) => {
      this.hideGlobalNav = hideNavBar;
    });

    // tslint:disable next-line no-any
    // if (!this.isWebChannel) {
    //   this.stateStore.addListener('app.profile.tmoId', (path: string, value: any) => {
    //     this.updateCartItemCount();
    //   });
    //   this.repDashwindow.addEventListener('closeAllAccounts', () => {
    //     this.updateCartItemCount();
    //   });
    //   this.repDashwindow.addEventListener('closeAccount', () => {
    //     this.updateCartItemCount();
    //   });
    // }
    if (this.stateStoreUtils.getSkipVerificationStatus()) {
      this.navBarService.navbarChangeEmitter.emit({ id: 'loggedIn' });
    }
    // this.shouldNavigateToPlanServices = SETTINGS.CHANNEL.toLocaleLowerCase() === 'retail';
  }
  /**
   * Handle the click on the topbar
   * @param event on mouse click navigates to external link
   * @returns void
   */
  public externalUrlClick(event: NavbarInterface): void {
    this.externalLink = event.targetLink;
    if (!event.openInNewtab) {
      this.modalData.toggleModalEmitter.emit({ open: true });
    }
  }
  /**
   * Handle the click events on the modal
   * @param event on mouse click navigates to external link
   * @returns void
   */
  public navigateToExternalUrl(event: any): void {
    const continueEventId: string = 'Continue';
    const WIN = window;
    if (event.name === continueEventId) {
      WIN.open(this.externalLink);
    }
  }
  /**
   * Called whenever a primary navigation menuLink is clicked.
   * It toggles the secondary menu, if it exists.
   * Or redirect the user as primary navigation route
   * @param menuLink - Link object
   * @param idx - number, to track the index of primary navigation link
   * @returns void
   */
  public onPrimaryMenu(menuLink: Link, idx: number): void {
    if (menuLink && menuLink.secondaryLinks && menuLink.secondaryLinks.length) {
      // if (idx === this.myTmobileIndex && !this.isWebChannel && !this.isLoggedIn) {
      //   return;
      // }
      if (idx !== this.openIndex) {
        this.openIndex = idx;
        let indexRemove: number = -1;
        menuLink.secondaryLinks.forEach((item: Link, index: number) => {
          if (
            item.label === PROFILE_PERMISSION_CONSTANTS.SWITCH_ACCOUNTS &&
            !this.hasMutipleAccount
          ) {
            indexRemove = index;
          }
        });
        if (indexRemove > -1) {
          menuLink.secondaryLinks.splice(indexRemove, 1);
        }
        this.secondaryMenu = this.navBarService.getFilteredLinks(menuLink.secondaryLinks);
        this.isMenuClosed = true;
        this.isSecondaryMenuOpen = true;
        this.navBarService.expandSecondaryNav();
      } else {
        this.closeSecondaryMenu();
      }
    } else {
      this.closeSecondaryMenu();
      this.closeVerticalMenu();
      // redirect logic
    }
  }
  /**
   * Called whenever a secondary navigation menuLink is clicked.
   * Redirects the user as secondary navigation route
   * @param secondaryMenuLink - Link object
   * @returns void
   */
  public onSubMenuItemClick(secondaryMenuLink: Link, index: number): boolean {
    const logout: string = 'Logout';
    this.secondaryMenuLink = secondaryMenuLink.label;
    this.subMenu = secondaryMenuLink.label;
    this.isMytmoSubMenus = false;
    this.targetUrl = this.domain + secondaryMenuLink.url;
    if (secondaryMenuLink.label === logout) {
      this.triggerClickEvent(-1, this.subMenu || 'default');
      this.logout();
    } else {
      this.triggerClickEvent();
    }
    this.updateShowMenuWithFalse();
    if (this.isDesktop) {
      this.onMainMenuItemClick(index);
    }
    return false;
  }
  /**
   * If customer or user logged need to remove stored data
   * @returns void
   */
  public logout(): void {
    // @TODO to be removed once validated in env
    // @TODO reverting code changes QC616682
    this.isLoggedIn = false;
    const win = window;
    this.closeSecondaryMenu();
    if (this.navBarService.isP10MCustomer) {
      this.userService.p10CustomerLoggedIn.next(false);
    }
    // if (this.isWebChannel) {
    this.customerProfileService
      .invalidateToken()
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((response: Response) => {
        this.stateStoreUtils.setRPXMigrationModalStatus(false);
        this.stateStore.clearState();
      });
    win.open(
      `${SETTINGS.EUIROOT}signout?redirect_uri=${win.location.protocol}//${win.location.host}`,
      '_self'
    );
    // } else {
    //   const customerId = this.stateStoreUtils.getCustomerId();
    //   const accountId = this.stateStoreUtils.getAccountId();
    //   // To close the account and set it default to Guest
    //   // @TODO PR:11858  for this PR accountsTabService is removed from PMLU this needs to be validated
    //   // this.accountsTabService.removeCustomerData(customerId, accountId, true);
    //   this.navBarService.removeCustomerData(customerId);
    //   if (!this.isWebChannel) {
    //     this.repDashwindow.RepdashEvent.dispatchEvent(new CustomEvent('clearRepdashInfo'));
    //   }
    //   this.router.navigate(['/']);
    // }
    this.customerProfileService
      .getPermissions()
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((permissions: HttpResponse<Object>) => {
        this.stateStoreUtils.setPermission(permissions.body);
        this.customerProfileService.permissionsLoadedSource.next(true);
        this.navBarService.permissionsUpdated.emit(true);
      });
    if (this.navBarService.isP10MCustomer) {
      this.userService.p10CustomerLoggedIn.next(false);
    }
  }
  /**
   * Called whenever hamburger menu link is called on device width less than 992px.
   * Toogles the value of isMenuOpen, to show or hide the menu.
   * @returns void
   */
  public toggleVerticalMenu(): void {
    this.isMenuClosed = !this.isMenuClosed;
  }
  /**
   * Called whenever hamburger menu link is called on device width less than 992px.
   * Closes or hides the menu on devices with width less than 992px
   * when user is redirected by clickin on primary/secondary menu link.
   * @returns void
   */
  public closeVerticalMenu(): void {
    if (!this.isDesktop) {
      this.isMenuClosed = true;
    }
  }

  /**
   * to reload the component if window resize
   * @param event on resizing of the screen gets the Primary navigations data
   * @returns void
   */
  public onResize(event: Event): void {
    if (this.navBarService.isDesktop()) {
      this.closeSecondaryMenu();
    }
    // Reset menu on resize
    this.setPrimaryDataAndGetMenuItems();
  }

  /**
   * Goto Cart from global nav icon
   * @returns void
   */
  public clickOnCart(): void {
    const shipTo = this.objectService.get(this.stateStoreUtils.getShipFulfillment(), 'shipTo');
    if (!this.cartSupportService.shouldNavigateToPlanServices(shipTo)) {
      const currentURL: string = this.router.url;
      const voucher = this.stateStoreUtils.getPrePurchasedPlanVoucherDetails();
      // if pre purchased plan in cart & if in product selector only (not in edit mode) delete cart
      if (
        voucher &&
        currentURL.indexOf('product-selector/activate') !== -1 &&
        currentURL.indexOf('line') === -1
      ) {
        this.cartSupportService
          .deleteCart()
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(() => {
            this.updateServiceBundle();
          });
      } else {
        this.partialLines = this.cartSupportService.getPartialLines();
        if (this.partialLines && this.partialLines.length > 0) {
          this.modal.toggleModalEmitter.emit({ open: true, close: false });
        } else {
          this.updateServiceBundle();
        }
      }
    }
  }

  /**
   * Navigate To Cart without saving partial lines
   * Service bundle api call for complete lines
   * @returns void
   */
  public navigateToCart(): void {
    this.modal.toggleModalEmitter.emit({ open: false, close: true });
    this.cartSupportService
      .deleteAllPartialLines(this.partialLines)
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((response: Cart) => {
        this.updateServiceBundle();
      });
  }

  /**
   * Service bundle api call for complete lines
   * @returns void
   */
  public updateServiceBundle(): void {
    this.cartSupportService
      .serviceBundleForCompleteLines()
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((response: Cart) => {
        this.cartSupportService.announceCartUpdate(response);
        // if (this.isRapChannel) {
        //   this.router.navigate(['/cart/review']);
        // }
        // else {
        this.targetUrl = this.domain + '/cart/review';
        this.subMenu = '';
        this.triggerClickEvent(-1, 'Cart');
        this.router.navigate(['/cart']);
        // }
      });
  }

  /**
   *  Method to destroy the data.
   * @returns void
   */
  public ngOnDestroy(): void {
    super.ngOnDestroy();
    this.navBarService.navbarChangeEmitter.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   * Dissmiss Partial line Modal
   * @returns void
   */
  public dissmissModal(): void {
    this.modal.toggleModalEmitter.emit({ open: false, close: true });
  }

  /**
   * Get all menu items
   * @returns void
   */
  public getMenuItems(): void {
    this.navigationData = { ...this.stateStoreUtils.getNavBarData() };
    this.filteredNavigationData = clone(this.navigationData);
    if (this.showConnect) {
      this.navigationData.leftLinks = this.navigationData.leftLinks.filter(
        (data: Link) => data.showConnect
      );
    } else {
      this.navigationData.leftLinks = this.navigationData.leftLinks.filter(
        (data: Link) => !data.showConnect
      );
    }
    this.filteredNavigationData.menuLinks = this.navBarService.getFilteredLinks(
      this.navigationData.menuLinks
    );

    if (this.objectService.get(this.filteredNavigationData, 'menuLinks.length') > 0) {
      this.firstMenuLinkLabel = this.objectService.get(
        this.filteredNavigationData.menuLinks,
        '0.label'
      );
      const menuLen = this.filteredNavigationData.menuLinks.length;
      for (let i = 0; i < menuLen; i++) {
        const secondaryLinks = this.objectService.get(
          this.filteredNavigationData.menuLinks,
          `${i}.secondaryLinks`
        );
        this.filteredNavigationData.menuLinks[i].secondaryLinks =
          this.navBarService.getFilteredLinks(secondaryLinks);
        this.isShowSubMenus[i] = false;
      }
    }

    if (this.objectService.get(this.filteredNavigationData, 'dropListLinks.length') > 0) {
      const dropLen = this.filteredNavigationData.dropListLinks.length;
      for (let i = 0; i < dropLen; i++) {
        const secondaryLinks = this.objectService.get(
          this.filteredNavigationData.dropListLinks,
          `${i}.secondaryLinks`
        );
        this.filteredNavigationData.dropListLinks[i].secondaryLinks =
          this.navBarService.getFilteredLinks(secondaryLinks);
      }
    }
  }

  /**
   * Toggle on click of main menu
   * @param index
   * @returns void
   */
  public onMainMenuItemClick(index: number, mouseLeave?: boolean | false): void {
    if (mouseLeave) {
      if (!this.isShowSubMenus[index] || this.lastMouseLeaveIndex === index) {
        return;
      } else {
        this.lastMouseLeaveIndex = index;
      }
    } else {
      this.lastMouseLeaveIndex = null;
    }
    this.closeSearchBox();
    this.triggerClickEvent(index);
    const two = 2;
    const menuCount = this.isShowSubMenus.length;
    // if (index === 0 && this.isWebChannel ) {
    if (index === 0) {
      this.stateStoreUtils.setZipCodeModalFlag(true);
    }
    for (let i = 0; i < menuCount; i++) {
      this.isShowSubMenus[i] = i === index ? !this.isShowSubMenus[i] : false;
    }

    if (this.isShowSubMenus.indexOf(true) > -1) {
      this.navBarService.expandSecondaryNav();
    } else {
      this.navBarService.collapseSecondaryNav();
    }
    this.isMytmoSubMenus = false;
  }
  /**
   * Toggles search box
   */
  public toggleSearchBox(): void {
    this.showSearchBar = !this.showSearchBar;
    this.isMytmoSubMenus = false;
    if (this.showSearchBar) {
      this.openSearchBox();
    } else {
      this.closeSearchBox();
    }
  }

  public userLogout(): void {
    // this.repDashwindow.RepdashEvent.dispatchEvent(new CustomEvent('userLogout'));
    this.userService.p10CustomerLoggedIn.next(false);
  }
  /**
   * handles the functionality to close search box and side menu when clicked anywhere outside on the page
   */
  public handleClickOutside(): void {
    this.showSearchBar = false;
  }
  /**
   * Open search box and toggles the other menu items
   */
  public openSearchBox(): void {
    this.updateShowMenuWithFalse();
    this.closeSecondaryMenu();
    this.closeVerticalMenu();
  }

  /**
   * Closes search box and toggles the other menu items
   */
  public closeSearchBox(): void {
    this.showSearchBar = false;
  }

  /**
   * Toggle on click of dropdown list
   * @param menuLink
   * @returns boolean
   */
  public onMytmobileMainMenuItemClick(menuLink: Link): boolean {
    if (this.isLoggedIn && this.objectService.get(menuLink, 'secondaryLinks.length') > 0) {
      let indexRemove: number = -1;
      menuLink.secondaryLinks.forEach((item: Link, index: number) => {
        if (
          item.label === PROFILE_PERMISSION_CONSTANTS.SWITCH_ACCOUNTS &&
          !this.hasMutipleAccount
        ) {
          indexRemove = index;
        }
      });
      if (indexRemove > -1) {
        menuLink.secondaryLinks.splice(indexRemove, 1);
      }
      this.navBarService.expandSecondaryNav();
      this.isMytmoSubMenus = !this.isMytmoSubMenus;
    } else {
      const auth: string = 'auth';
      const navParams = {
        path: auth,
        lang: '',
      };
      navParams.lang = this.isEspanol ? 'es' : '';
      this.router.navigate([auth, navParams]);
      this.isMytmoSubMenus = false;
    }
    this.updateShowMenuWithFalse();
    return false;
  }

  /**
   * Update sub menus list with false value
   */
  private updateShowMenuWithFalse(): void {
    const menuCount = this.isShowSubMenus.length;
    for (let i = 0; i < menuCount; i++) {
      this.isShowSubMenus[i] = false;
    }
  }

  /**
   * To redirect user to store locator page.
   * @param url - String url of the new route
   * @param isNewTab - boolean to open in new tab or not
   * @returns boolean
   */
  public navigateToRoute(url: string, isNewTab: boolean): boolean {
    if (!this.stateStoreUtils.getAuthCustomerId() && url === SHARED_CONSTANTS.ACCOUNT_LANDING) {
      url = SHARED_CONSTANTS.HOME;
    }
    if (url === 'https://www.t-mobile.com/store-locator.html') {
      this.targetUrl = url;
      this.subMenu = '';
      this.triggerClickEvent(-1, 'Store Locator');
    }
    this.commonUtilService.routeToGivenUrl(url, isNewTab);
    return false;
  }

  /**
   * Function to get menu items and set primary navigation data
   */
  private setPrimaryDataAndGetMenuItems(): void {
    this.getMenuItems();
    this.setPrimaryNavigationData();
  }
  private setPrimaryNavigationData(): void {
    this.isDesktop = this.navBarService.isDesktop();
    this.navigationData = { ...this.stateStoreUtils.getNavBarData() };
    if (this.showConnect) {
      this.navigationData.leftLinks = this.navigationData.leftLinks.filter(
        (data: Link) => data.showConnect
      );
    } else {
      this.navigationData.leftLinks = this.navigationData.leftLinks.filter(
        (data: Link) => !data.showConnect
      );
    }
    this.navigationData.menuLinks = this.navBarService.getFilteredLinks(
      this.navigationData.menuLinks
    );
    if (this.isLoggedIn && !this.isDesktop) {
      this.onPrimaryMenu(this.navigationData.dropListLinks[1], this.myTmobileIndex);
    }
  }

  private closeSecondaryMenu(): void {
    this.openIndex = -1;
    this.secondaryMenu = [];
    this.isSecondaryMenuOpen = false;
    this.navBarService.collapseSecondaryNav();
  }

  /**
   * Update cart item number in cart icon
   */
  private updateCartItemCount(): void {
    const cart = this.stateStoreUtils.getCart();
    const offerId = this.objectService.get(cart, 'lines.0.plan.0.offerId') || '';
    const cartLines: CartLine[] = this.objectService.get(cart, 'lines') || [];
    const standAloneDeviceCount: number = this.objectService.get(cart, 'devices.length') || 0;
    const accessoryCount: number = this.objectService.get(cart, 'accessories.length') || 0;
    const returningItem: number = this.objectService.get(cart, 'returningItem.length') || 0;
    const replacementItem: number = this.objectService.get(cart, 'replacementItem.length') || 0;
    let lineDeviceCount: number = 0;
    let simKitCount: number = 0;
    this.stateStoreUtils.setAutoPayDiscountEligiblePlansInCart({});

    cartLines.forEach((cartLine: CartLine) => {
      if (cartLine.plan && cartLine.plan.length) {
        cartLine.plan.forEach(plan => {
          this.trackAutoPayEligiblePLans(plan);
        });
      }
      lineDeviceCount =
        this.objectService.get(cartLine, `device.sku`) &&
        this.objectService.get(cartLine, `device.actionCode`) === SHARED_CONSTANTS.ACTION_CODE_ADD
          ? lineDeviceCount + 1
          : lineDeviceCount;
      lineDeviceCount = this.objectService.get(cartLine, `returningItem`)
        ? lineDeviceCount + 1
        : lineDeviceCount;
      lineDeviceCount = this.objectService.get(cartLine, `replacementItem`)
        ? lineDeviceCount + 1
        : lineDeviceCount;
      simKitCount = this.objectService.get(cartLine, `simKit.sku`) ? simKitCount + 1 : simKitCount;
    });
    this.cartItemCount =
      lineDeviceCount +
      simKitCount +
      standAloneDeviceCount +
      accessoryCount +
      returningItem +
      replacementItem;
    /* Cookie Setting for Phoenix */
    if (this.cartItemCount) {
      this.cartSupportService.setPhoenixCookie({ cartItemCount: this.cartItemCount });
    } else if(!offerId){ 
      const utcTime = this.cartSupportService.getUTCTime(1, false);
      this.cartSupportService.clearPhoenixCookie({ utcTime: utcTime });
    }
    /* Cookie Setting for Phoenix */
    // if (!this.isWebChannel && !this.stateStoreUtils.getCustomerId()) {
    //   this.dispatchCartItemCount();
    // }
    this.cartSupportService.cartCountUpdatedSource.next();
  }

  private trackAutoPayEligiblePLans(plan: CartItem) {
    const autoPayDiscountEligiblePlansInCart = this.stateStoreUtils.getAutoPayDiscountEligiblePlansInCart();
    const isPlanEligible = plan.autoPayAllowed;
    const autoPayEligibility: AutoPayDiscountEligiblePlanInCart = {
      inAccount: (autoPayDiscountEligiblePlansInCart.inAccount || 0) + ((plan.actionCode === SHARED_CONSTANTS.ACTION_CODE_RETAIN && isPlanEligible) ? 1 : 0),
      inCart: (autoPayDiscountEligiblePlansInCart.inCart || 0) + ((plan.actionCode !== SHARED_CONSTANTS.ACTION_CODE_RETAIN && isPlanEligible) ? 1 : 0)
    }
    this.stateStoreUtils.setAutoPayDiscountEligiblePlansInCart(autoPayEligibility);
  }

  /**
   * Posts custom event to repdash
   * @param selectedLine
   */
  // private dispatchCartItemCount(): void {
  //   this.repDashwindow.RepdashEvent
  //     .dispatchEvent(new CustomEvent('cartItemCount',
  //       {
  //         detail: {
  //           count: this.cartItemCount
  //         }
  //       }));
  // }

  public switchLanguage(lang: string): boolean {
    MP.SrcUrl = decodeURIComponent('mp_js_orgin_url');
    MP.UrlLang = 'mp_js_current_lang';
    MP.init();
    let MPLang: string;
    MPLang = MP.UrlLang === lang ? 'en' : lang;
    if (this.isLoggedIn) {
      const auth: string = 'auth';
      this.router.navigate([auth, { path: auth, lang: MPLang }]);
    } else {
      MP.switchLanguage(MPLang);
    }
    return true;
  }
  /**
   * Update cart navbar permissions
   */
  private updateNavbarPermission(): void {
    this.isAddLinePermission = this.featureToggleUtilService.getFraudLockPermission(
      SHARED_CONSTANTS.GLOBAL,
      PERMISSION_CONSTANTS.ADD_A_LINE
    );
    this.isPermissionAvailable = this.featureToggleUtilService.getFraudLockPermission(
      SHARED_CONSTANTS.GLOBAL,
      PERMISSION_CONSTANTS.ORDER_DEVICE
    );
    this.isOrderDevicePermission = this.featureToggleUtilService.getFraudLockPermission(
      SHARED_CONSTANTS.GLOBAL,
      PERMISSION_CONSTANTS.PRE_ORDER_DEVICE
    );
    this.isAccessoryPermission = this.featureToggleUtilService.getFraudLockPermission(
      SHARED_CONSTANTS.GLOBAL,
      PERMISSION_CONSTANTS.ORDER_ACCESSORY
    );
  }

  private triggerClickEvent(index?: number, category?: string): void {
    let submenu = true;
    // if (this.isWebChannel) {
    if (index > -1) {
      this.index = index;
      submenu = false;
    }
    const mainMenuLinkDetail = this.objectService.get(
      this.filteredNavigationData,
      `menuLinks.${this.index}`,
      {}
    );
    this.setTargetURL(index);
    this.eventData = {
      eventInfo: {
        eventAction: 'click',
        eventType: 'navigation',
      },
      eventDescription: {
        navType: this.isDesktop ? 'tNav' : 'hNav',
        category: category
          ? category
          : this.objectService.get(
              this.filteredNavigationData,
              `menuLinks.${this.index}.label`,
              ''
            ),
        subCategory: submenu ? this.subMenu : '',
        targetUrl: this.targetUrl,
      },
    };
    if (
      (mainMenuLinkDetail.secondaryLinks && mainMenuLinkDetail.secondaryLinks.length === 0) ||
      submenu
    ) {
      if (!this.isDesktop) {
        this.toggleVerticalMenu();
      }
      this.pdlService.triggerCustomEvent(this.pdlPageComponentId, 'click');
    }
    // }
  }

  private setTargetURL(index?: number): void {
    if (index > 1) {
      const url = this.objectService.get(
        this.filteredNavigationData,
        `menuLinks.${this.index}.url`,
        ''
      );
      this.targetUrl = url.includes('://') ? url : `${this.domain}${url}`;
    }
  }

  public hideVerticalMenu(): void {
    for (let i = 0; i < this.isShowSubMenus.length; i++) {
      this.isShowSubMenus[i] = this.isShowSubMenus[i] ? !this.isShowSubMenus[i] : false;
    }
  }
}
